import type { AccentColor } from '@udbodhanam/shared';

export function applyAccentColor(color: AccentColor) {
  try { localStorage.setItem('udb_accent', color); } catch { /* ignore */ }
  if (color === 'flame') {
    document.documentElement.removeAttribute('data-accent');
  } else {
    document.documentElement.setAttribute('data-accent', color);
  }
}
